import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { ShippingArrivalDetailModel, ShippingArrivalModel } from 'src/app/shared/models/rma.model';
import { UserModel } from 'src/app/shared/models/user.model';
import { RmaService } from 'src/app/shared/services/rma.service';
import { UserService } from 'src/app/shared/services/user.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-rma-shipping-arrivals-list',
  templateUrl: './rma-shipping-arrivals-list.component.html',
  styleUrls: ['./rma-shipping-arrivals-list.component.css']
})
export class RmaShippingArrivalsListComponent implements OnInit {
/*

  @Input() call : CallModel;
  @Input() users : UserModel [];
  @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();
*/

  thisData : MatTableDataSource<any>;
  displayColumn : string[]= ['arrivalDate', 'courierName', 'trackingNo', 'shipper', 'rmaCode', 'note', 'receiver', 'actions'];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;
  users : UserModel[];
  constructor(private service : RmaService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private router : Router,
    private userService : UserService
    /*private dialog : MatDialog */) {

      console.log("RmaShippingArrivalsListComponent");

    }

  ngOnInit() {
    this.userService.getUserList().subscribe(
      res=>{
        console.log("getUserList");
        this.users = res as UserModel [];
        this.refreshList();
      },
      err=>{}
    );


    this.refreshList();
  }

  onDelete(id)
  {
    console.log("onDelete : " + id);

    if(!confirm("Are you sure to delete this issue?")) return;
    this.service.deleteData(id).subscribe(
      res=>{
        ////this.toastr.warning("Submitted successfully", "RMA Shipping Arrival Delete");
        this.gnotify.showSnackBar('RMA Shipping Arrival Delete', 'Submitted successfully', "warning");
        this.searchKey = "";
        this.refreshList();
      },
      err=>{
        console.log(err);
      }
    );
  }

  refreshList()
  {
    this.service.getList().subscribe(
      res => {
        let array = res as ShippingArrivalDetailModel[];
        let result = array.map(
          obj => {
            obj.createByUser = this.users.find(item => item.id === obj.createBy);
            return {...obj}
          }
        );

        this.thisData = new MatTableDataSource(array);
        this.thisData.sort = this.sort;
        this.thisData.paginator = this.paginator;

        console.log("refreshList : " + this.thisData.data.length);

        this.applyFilter();

       },
       err =>{
         console.log(err);
       }
    );

  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter()
  {

    if(this.searchKey == null) return;
    console.log("applyFilter");
    this.thisData.filter = this.searchKey.trim().toLowerCase();
  }

  onCreate()
  {
     this.router.navigateByUrl('rma-shipping-arrivals-edit');
   // this.onSelected.emit();
  }

  onEdit(row){
    this.router.navigateByUrl('rma-shipping-arrivals-edit/' + row.arrivalId);
  //  this.onSelected.emit(row);
  }

}
